import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, post } from '../models/base';

export const fetchPhotos = createAsyncThunk(
  'photos/fetchPhotos',
  async (folderId, { rejectWithValue, getState }) => {
    const { album, albumId } = getState().album;
    const { folders } = getState().folders;
    const { pageNumber, perPage } = getState().photos;
    folderId = folderId || folders[0].id;

    try {
      const queryPath = `/albums/${albumId}/folders/${folderId}/photos?page=${pageNumber}&per_page=${perPage}`;
      const response = await get(queryPath);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchFailedPhotos = createAsyncThunk(
  'photos/fetchFailedPhotos',
  async (_, { rejectWithValue, getState }) => {
    const { album } = getState().album;
    const { folder } = getState().folders;
    const { photoIdList } = getState().photos;
    let queryPath = `/albums/${album.id}/folders/${folder.id}/photos/failed_photos`;

    try {
      const response = await post(queryPath, { photo_ids: photoIdList });
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
